import React, { Component, useState } from 'react'
import { Card, Button, Input, Col, Row, Popconfirm, Alert, message } from 'antd'
import './DeskTicketInformation.scss'
import { TeamRequest } from 'models/request/TeamRequest'
import { getAgentsByTeam, setAgents } from 'services/CeberusApiService'
import { TenantService } from 'connection/TenantService'
import { AgentRequest } from 'models/request/AgentRequest'
import { BaseRequest } from 'models/request/BaseRequest'

export class DeskAgentsTeamManagement extends Component<BaseRequest> {
  
  state = {
      isLoading: false,
      ticketsInformation: [],
      filter: {
        sequentialId: '',
        agentId: '',
        customerId: ''
      },
      currentTeamName: null,
      newTeamName: null
  }

  success = () => {
    message.success('Team was changed')
  }

  error = (errorDescription) => {
    message.error(errorDescription)
  }

  formatTeams(teams) {
    let newTeams = teams.map(team => {
      if (team === this.state.currentTeamName) {
        if(this.state.newTeamName) {
          return this.state.newTeamName
        } else {
          if (teams.length === 1) {
            return 'Default'
          }
        }
        return undefined
      } else {
        return team
      }
    }).filter((valids) => {
      return valids != null
    })

    newTeams = Array.from(new Set(newTeams))
    return newTeams
  }

  async replaceTeam() {
    const agents = await this.getAgentsByTeamAsync()
    if (agents !== undefined) {
      const hasCurrentTeam = agents.some(a => a.teams.includes(this.state.currentTeamName))
      this.checkAndSetAgents(agents, hasCurrentTeam)
    } else {
      this.error('This current team does not exist')
    }
  }

  checkAndSetAgents = async (agents, hasCurrentTeam) => {
    if (hasCurrentTeam) {
      const attendants = agents.map(agent => {
        return {
          identity: agent.identity,
          teams: this.formatTeams(agent.teams)
        }
      })
      await this.setAgentsByTeam(attendants)

    } else {
      this.error('This current team does not exist')
    }
  }

  getAgentsByTeamAsync = async () => {
    try {
      const teamRequest = new TeamRequest()
      teamRequest.TeamName = this.state.currentTeamName
      teamRequest.BotIdentifier = this.props.BotIdentifier
      teamRequest.ClusterName = TenantService.getSelectedTenant().name
      const { items : agents } = await getAgentsByTeam(teamRequest)
      return agents
    } catch (e) {
      return undefined
    }
  }

  setAgentsByTeam = async (attendants) => {
    try {
      const agentRequest = new AgentRequest()
      agentRequest.Attendants = attendants
      agentRequest.BotIdentifier = this.props.BotIdentifier
      agentRequest.ClusterName = TenantService.getSelectedTenant().name
      await setAgents(agentRequest)
      this.success()
    } catch (e) {
      this.error('There was a problem deleting this team')
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <Card>
        <Alert type="info" message="*If the attendant has only one team, it will be replaced by Default"  showIcon />
        <Input.Group size="large">
          <Row gutter={8}>
            <Col span={8}>
              <span>Current Team Name</span>
              <Input name="currentTeamName" onChange={this.handleInputChange} />
            </Col>
            <Col span={8}>
              <span>New Team Name</span>
              <Input name="newTeamName" placeholder="Current team will be deleted if this is empty" onChange={this.handleInputChange} />
            </Col>
          </Row><br />
          <Popconfirm placement="right" disabled={!this.state.currentTeamName} title="Are you sure to replace this team?" onConfirm={() => this.replaceTeam()} okText="Yes" cancelText="No">
            <Button type="primary" disabled={!this.state.currentTeamName}>
              Replace
            </Button>
          </Popconfirm>
        </Input.Group>
      </Card>
    )
  }
}